import { accessPolicyType, goalProgressMeasurement } from 'shared/constants.json';

const canRead = (goal) => goal.accessRight !== accessPolicyType.disabled;

const canWrite = (goal) => [accessPolicyType.write, accessPolicyType.full].includes(goal.accessRight);

export const canPayOnto = (parent) => canWrite(parent) && parent.progressMeasurement === goalProgressMeasurement.alignedItems;

export const includeChildren = (parent, children) => children
  .filter((c) => canRead(c)
    && c.progressMeasurement !== goalProgressMeasurement.none
    && !c.paysOnto.some((p) => p.uid === parent.uid))
  .map((c) => ({ uid: c.uid, paysOnto: [...c.paysOnto, { uid: parent.uid }] }));
